/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../style/index.css';
import '../style/markdown.css';
import '../common/Analytics/clickStream';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { AppRouter } from './components/router/Router';
import { getStore } from '../reducers';
import '../i18n';

let root: ReactDOM.Root;
const render = (Component) => {
  if (!root) {
    root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  }
  root.render(
    <AppContainer>
      <Provider store={getStore()}>
        <Component />
      </Provider>
    </AppContainer>,
  );
};

render(AppRouter);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ((module as any).hot) {
  (module as any).hot.accept('./components/router/Router', () => {
    const NextApp = require('./components/router/Router').AppRouter;
    render(NextApp);
  });
}
